import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/cart";
import { getMechanicBanners } from "../../services/promotion";
import { BANNER_ACTION } from "../../constants/banner";
import { SKUS_QUERY_STRING } from "../../constants/skus";
import { APP_PATHS } from "../../constants/paths";
import ImagePlaceholder from "../ui/ImagePlaceholder/ImagePlaceholder";
import Ripple from "../ui/spinners/ripple/Ripple";
import Swiper from "../Swiper/Swiper";
import SwiperSlide from "../Swiper/SwiperSlide/SwiperSlide";
import classes from "./Banner.module.css";

const Banner = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedMechanic = useSelector((state) => state.mechanic);

  const [banners, setBanners] = useState([]);
  const [isBannersLoading, setIsBannersLoading] = useState(false);
  const [bannersLoadingError, setBannersLoadingError] = useState("");

  const searchSkusHandler = (data) => {
    const searchParams = [];
    const {
      skuCategoryId,
      skuSubCategoryId,
      skuBrandIdList,
      skuNameIdList,
      skuIdList,
    } = data.searchParams;

    if (skuCategoryId) {
      searchParams.push(`${SKUS_QUERY_STRING.CATEGORY_ID}=${skuCategoryId}`);
    }
    if (skuSubCategoryId) {
      searchParams.push(
        `${SKUS_QUERY_STRING.SUB_CATEGORY_ID}=${skuSubCategoryId}`
      );
    }

    if (skuBrandIdList?.length) {
      searchParams.push(`${SKUS_QUERY_STRING.SKU_BRANDS}=${skuBrandIdList}`);
    }

    if (skuNameIdList?.length) {
      searchParams.push(`${SKUS_QUERY_STRING.SKU_NAMES}=${skuNameIdList}`);
    }

    if (skuIdList?.length) {
      searchParams.push(`${SKUS_QUERY_STRING.SKU_IDS}=${skuIdList}`);
    }

    navigate(`${APP_PATHS.SKUS}?${searchParams.join("&")}`);
  };

  const addSkusToCartHandler = async (skus) => {
    for (const sku of skus) {
      const skuToAdd = {
        ...sku,
        availableQuantity: sku.quantity,
      };
      skuToAdd.quantity = 1;
      dispatch(addToCart(skuToAdd));
    }

    navigate(APP_PATHS.MY_CART);
  };

  const bannerClickedHandler = (action, data) => {
    switch (action) {
      // case BANNER_ACTION.PROMOTION:
      //   navigate(APP_PATHS.PROMOTIONS.url, { state: data.promotionId });
      //   break;
      // case BANNER_ACTION.SKU_DETAILS:
      //   navigate(APP_PATHS.SKU_DETAILS.url.replace(":skuId", data.skuId));
      //   break;
      case BANNER_ACTION.REDIRECT_URL:
        window.open(data?.redirectUrl, "_blank", "noopener,noreferrer");
        break;
      case BANNER_ACTION.SEARCH:
        searchSkusHandler(data);
        break;
      case BANNER_ACTION.CART:
        addSkusToCartHandler(data.skuList);
        break;
      default:
        return;
    }
  };

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        setIsBannersLoading(true);
        setBannersLoadingError("");
        const response = await getMechanicBanners(selectedMechanic?.id);
        const {
          data: { promotionDetailsList },
        } = response;
        setBanners(promotionDetailsList);
      } catch (err) {
        setBannersLoadingError(
          "حدث خطأ أثناء تحميل لافتات العروض و الخصومات !"
        );
      } finally {
        setIsBannersLoading(false);
      }
    };

    if (selectedMechanic?.id) {
      fetchBanners();
    }
  }, [selectedMechanic?.id]);

  return (
    <section className={classes["banner-container"]}>
      {isBannersLoading ? (
        <Ripple className="border-dark-blue" />
      ) : bannersLoadingError || banners.length === 0 ? null : (
        <div className={classes["banner-container__banners"]}>
          <Swiper
            className={classes["banner-container__swiper"]}
            numberOfSlides={banners.length}
            slidesPerView="auto"
            autoplay
          >
            {banners.map((banner, index) => (
              <SwiperSlide
                className={classes["banner-slide"]}
                key={index}
                data-swiper-autoplay={banner.duration * 1000}
              >
                <ImagePlaceholder
                  src={banner.imageUrl || ""}
                  alt="banner"
                  className={classes["banner-slide__img"]}
                  role="button"
                  onClick={() =>
                    bannerClickedHandler(banner.action, banner.data)
                  }
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </section>
  );
};

export default Banner;
